import { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { OrganizationDto } from '../../../api/services/dto/user-managment-dto/organization-dto';
import { warrantService } from '../../../api/services/warrant.service';
import { useWorkspace } from '../../../context/WorkspaceContext';

const WorkspaceSwitcher = () => {
  const { workspace, setWorkspace } = useWorkspace();
  const [organizations, setOrganizations] = useState<OrganizationDto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    warrantService
      .fetchOrganizationsOrderedAlphabetically()
      .then(setOrganizations)
      .catch(() => setOrganizations([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: 'rgba(0, 0, 0, 0.6)' }}>
        Workspace
      </Typography>
      <Autocomplete
        size="small"
        options={organizations}
        getOptionLabel={(option) => option.name || ''}
        value={workspace}
        loading={loading}
        onChange={(_, newValue) => setWorkspace(newValue)}
        isOptionEqualToValue={(option, value) => option.organizationId === value.organizationId}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="My Workspace"
            variant="outlined"
            sx={{ minWidth: 300 }}
          />
        )}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#F5F5F5',
          },
        }}
      />
    </Box>
  );
};

export default WorkspaceSwitcher;
